import { render, staticRenderFns } from "./serviceSonsultList.vue?vue&type=template&id=2538fa4f&scoped=true"
import script from "./serviceSonsultList.vue?vue&type=script&lang=js"
export * from "./serviceSonsultList.vue?vue&type=script&lang=js"
import style0 from "./serviceSonsultList.vue?vue&type=style&index=0&id=2538fa4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2538fa4f",
  null
  
)

export default component.exports